import React, { useEffect, useState } from "react";

const ARCADE_RETURN_KEY = "pogforts.arcadeReturn";
const ARCADE_PATHS = new Set(["/roulette", "/batrunner", "/video-poker"]);

function consumeArcadeReturnPath() {
  try {
    const path = window.sessionStorage.getItem(ARCADE_RETURN_KEY);
    window.sessionStorage.removeItem(ARCADE_RETURN_KEY);
    return ARCADE_PATHS.has(path) ? path : "/online/profile";
  } catch {
    return "/online/profile";
  }
}

function clearArcadeReturnPath() {
  try { window.sessionStorage.removeItem(ARCADE_RETURN_KEY); }
  catch { /* Storage can be unavailable in restricted browsers. */ }
}

const DiscordAuthHandler = () => {
  const [message, setMessage] = useState("Authorising secure Discord login...");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const loginStatus = params.get("login");

    const isLocalDev =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    const apiBase = isLocalDev ? "http://localhost:5000" : "";

    const finishLogin = async () => {
      if (loginStatus === "success") {
        try {
          const response = await fetch(`${apiBase}/api/auth/me`, {
            credentials: "include",
            cache: "no-store",
          });

          if (!response.ok) {
            throw new Error("Session verification failed");
          }

          setMessage("Login successful. Redirecting...");
          window.location.replace(consumeArcadeReturnPath());
          return;
        } catch (error) {
          clearArcadeReturnPath();
          console.error("Discord login verification failed:", error);
          setMessage("Login completed, but session verification failed.");
          setTimeout(() => {
            window.location.replace("/");
          }, 1500);
          return;
        }
      }

      clearArcadeReturnPath();
      if (loginStatus === "denied") {
        setMessage("Discord login was denied.");
        setTimeout(() => {
          window.location.replace("/");
        }, 1500);
        return;
      }

      setMessage("Discord login failed.");
      setTimeout(() => {
        window.location.replace("/");
      }, 1500);
    };

    finishLogin();
  }, []);

  return <p>{message}</p>;
};

export default DiscordAuthHandler;